{
  "title": "Configuration tester",
  "subtitle": "What is actually true about this tenant's mail path, and what nobody has checked.",
  "loadError": "Could not load test results",
  "runChecks": "Run checks",
  "pass": "Pass",
  "fail": "Fail",
  "skip": "Not run",
  "warn": "Warn",
  "ignored": "Ignored",
  "history": "Run history",
  "pasteReport": "Paste a report",
  "pasteHint": "Paste the output of Test-TenantMailFlow.ps1 to file Exchange connector evidence.",
  "submitReport": "Submit report",
  "groupDns": "DNS",
  "groupM365": "Microsoft 365",
  "groupGoogle": "Google Workspace",
  "groupMailPath": "Mail path",
  "noteDns": "Checked from here, against public DNS over DNS-over-HTTPS. These are the checks the platform can genuinely make on its own.",
  "noteM365": "Exchange connectors and transport rules have no Graph API, and this build has no Graph client at all. Every answer in this group comes from a Test-TenantMailFlow.ps1 report an operator pasted in.",
  "noteGoogle": "Google Workspace integration does not exist in this codebase yet. These rows are here so that absence is visible rather than silent — none of them will ever pass until the integration is built.",
  "noteMailPath": "The platform checking itself: its own listener, its own certificates, its own snapshot delivery.",
  "loopbackBlocking": "Smart-host loopback is failing. Fix that before promoting to org-wide — outbound mail would bounce.",
  "loopbackTitle": "Smart host resolves to loopback",
  "checkedAge": "Checked {{age}}.",
  "checksFailedTitle": "{{count}} checks failed",
  "checksFailedBody": "A failing check means this tenant's mail path is misconfigured now, not that it might be later. Use Ignore on a row only when the fail is known noise for this tenant.",
  "checksSkippedTitle": "{{count}} checks did not run",
  "checksSkippedBody": "This tenant is not verified. The checks below marked \"not run\" have no result at all — they are not passing quietly, and nothing should be read into their absence except that nobody has looked.",
  "ignore": "Ignore",
  "unignore": "Stop ignoring",
  "sourceAutomated": "Automated",
  "sourcePasted": "Pasted report",
  "sourceServer": "Server",
  "sourceUnknown": "Unknown",
  "provenancePasted": "pasted",
  "provenanceSkipped": "skipped in a run",
  "provenanceChecked": "checked",
  "groupNothingRan": "Nothing in this group has been checked. These rows are not passing quietly — they were never run at all.",
  "groupNoResults": "No results yet. Run this group, or paste a report that covers it.",
  "tookMs": "Took {{ms}} ms.",
  "ignoreHintFail": "Dismisses this fail from tallies and gates. Survives re-runs.",
  "ignoreHintWarn": "Dismisses this warning from tallies and gates. Survives re-runs.",
  "pasteTitle": "Paste a Test-TenantMailFlow report",
  "pasteIntro": "Prefer Run automated validation above when the connector app can reach Exchange. Paste remains break-glass: run this in an Exchange Online session connected to the customer, then paste the JSON it printed.",
  "scriptTitle": "Test-TenantMailFlow.ps1",
  "scriptDescription": "Read-only. Checks live public DNS over DNS-over-HTTPS rather than the machine's resolver, so a split-horizon answer cannot look reassuring.",
  "reportJson": "Report JSON",
  "reportJsonDescription": "Everything from the opening brace to the closing one.",
  "reportJsonPlaceholder": "{ \"Organization\": \"contoso.onmicrosoft.com\", \"Checks\": [ ... ] }",
  "reportInvalidTitle": "This report cannot be filed",
  "reportCompleteTitle": "Report looks complete",
  "reportSummary": "{{checks}} checks from {{organization}}, run {{when}}: {{pass}} pass, {{warn}} warn, {{fail}} fail, {{skip}} not run.",
  "fileError": "Could not file the report",
  "fileReport": "File this report",
  "filed": "Report filed against this tenant.",
  "filePermissionHint": "A filed report becomes this tenant's evidence, so tenant administrators and above can file one. Running the command and reading the output needs no role at all.",
  "historyWhen": "When",
  "historySource": "Source",
  "historyResult": "Result",
  "historyEmpty": "This tenant has never been tested.",
  "historyPass": "{{count}} pass",
  "historyWarn": "{{count}} warn",
  "historyFail": "{{count}} fail",
  "historySkip": "{{count}} not run"
}
